<section class="pt-16 pb-4 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Area Compagnie', route: '/backoffice/area-compagnie/' }, { label: 'Scheda Compagnia', active: true }]"></app-breadcrumb-backoffice>
</section>

@if (!loading && summary) {
<section class="px-container pb-4">
    <div class="scheda-stato">
        <div class="scheda-stato-cell">
            <span class="scheda-stato-label">Documenti</span>
            <span class="scheda-stato-pill" [ngClass]="summary.status.doc">{{ statusLabel(summary.status.doc) }}</span>
        </div>
        <div class="scheda-stato-cell">
            <span class="scheda-stato-label">Personale</span>
            <span class="scheda-stato-pill plain">{{ summary.n_personale }} {{ summary.n_personale === 1 ? 'membro' : 'membri' }}</span>
        </div>
        <div class="scheda-stato-cell">
            <span class="scheda-stato-label">Subappalti</span>
            <span class="scheda-stato-pill plain">{{ summary.n_subappalti }}</span>
        </div>
        <div class="scheda-stato-cell">
            <span class="scheda-stato-label">Mezzi</span>
            <span class="scheda-stato-pill plain">{{ summary.n_mezzi || 0 }}</span>
        </div>
        <div class="scheda-stato-cell">
            <span class="scheda-stato-label">Segnalazioni</span>
            <span class="scheda-stato-pill" [ngClass]="noteStatus.cls">{{ noteStatus.text }}</span>
        </div>
        @if (evento?.id_spettacolo) {
            <div class="scheda-stato-cell">
                <button type="button" class="acc-btn" (click)="utenzeDialog = true">Utenti</button>
            </div>
        }
    </div>
</section>
}

<app-accredito-backoffice *ngIf="!loading" [evento]="evento" (noteChanged)="reloadNote()"></app-accredito-backoffice>
<app-loading-backoffice [visible]="loading"></app-loading-backoffice>

<p-dialog [(visible)]="utenzeDialog" styleClass="accrediti-dialog" [modal]="true" [style]="{ width: 'min(920px, 96vw)', maxHeight: '90vh' }" [contentStyle]="{ maxHeight: 'calc(90vh - 4.5rem)', overflow: 'auto' }" header="Utenti compagnia" [focusOnShow]="false" (onHide)="utenzeDialog = false">
    @if (utenzeDialog && evento?.id_spettacolo) {
        <app-utenti-accredito-spettacolo-backoffice [embed]="true" [idSpettacolo]="evento!.id_spettacolo" />
    }
</p-dialog>
